"use client";

import { useState } from "react";
import { Play, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const filters = [{
  id: "all",
  label: "[ ALL ]"
}, {
  id: "bridal",
  label: "[ BRIDAL ]"
}, {
  id: "editorial",
  label: "[ EDITORIAL ]"
}, {
  id: "transformations",
  label: "[ TRANSFORMATIONS ]"
}];
const frames = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bridal_classic_glow.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bridal_classic_glow.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bridal_classic_glow.png-wvc-sizes",
  alt: "Flawless bridal makeup with soft glow",
  project: "CLASSIC BRIDAL",
  location: "STUDIO A",
  year: "2025",
  category: "bridal",
  aspect: "aspect-[4/5]"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/editorial_high_fashion.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/editorial_high_fashion.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/editorial_high_fashion.png-wvc-sizes",
  alt: "High-fashion editorial makeup look",
  project: "VOGUE EDIT",
  location: "ON-SITE",
  year: "2025",
  category: "editorial",
  aspect: "aspect-[21/9]"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/before_after_transformation.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/before_after_transformation.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/before_after_transformation.webp-wvc-sizes",
  alt: "Before and after makeup transformation",
  project: "SKIN REVEAL",
  location: "STUDIO B",
  year: "2025",
  category: "transformations",
  aspect: "aspect-square"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/editorial_runway_look.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/editorial_runway_look.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/editorial_runway_look.png-wvc-sizes",
  alt: "Cinematic runway makeup style",
  project: "RUNWAY GLOW",
  location: "STUDIO A",
  year: "2025",
  category: "editorial",
  aspect: "aspect-[16/9]"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bridal_boho_style.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bridal_boho_style.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bridal_boho_style.png-wvc-sizes",
  alt: "Boho bridal makeup with natural tones",
  project: "BOHO BRIDE",
  location: "ON-SITE",
  year: "2025",
  category: "bridal",
  aspect: "aspect-[4/5]"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/transformation_contour.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/transformation_contour.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/transformation_contour.png-wvc-sizes",
  alt: "Contouring transformation detail",
  project: "STRUCTURED GLOW",
  location: "STUDIO B",
  year: "2025",
  category: "transformations",
  aspect: "aspect-[16/9]"
}, {
  id: 7,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/editorial_avant_garde.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/editorial_avant_garde.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/editorial_avant_garde.png-wvc-sizes",
  alt: "Avant-garde editorial makeup",
  project: "AVANT GLOW",
  location: "STUDIO A",
  year: "2025",
  category: "editorial",
  aspect: "aspect-[21/9]"
}, {
  id: 8,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bridal_glam_look.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bridal_glam_look.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/bridal_glam_look.png-wvc-sizes",
  alt: "Glamorous bridal makeup look",
  project: "GLAM BRIDE",
  location: "ON-SITE",
  year: "2025",
  category: "bridal",
  aspect: "aspect-square"
}, {
  id: 9,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/transformation_skin_finish.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/transformation_skin_finish.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701512/img/transformation_skin_finish.png-wvc-sizes",
  alt: "Skin finish transformation",
  project: "LUMINOUS SKIN",
  location: "STUDIO B",
  year: "2025",
  category: "transformations",
  aspect: "aspect-[4/5]"
}];
export default function BridalElegance() {
  const [activeFilter, setActiveFilter] = useState("all");
  const [openId, setOpenId] = useState<number | null>(null);
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const filtered = activeFilter === "all" ? frames : frames.filter(f => f.category === activeFilter);
  const activeFrame = frames.find(f => f.id === openId) ?? null;
  return <section data-section-id="2416" id="bridal-elegance" className="bg-background text-foreground py-24 md:py-32 lg:py-40 px-6 md:px-10 lg:px-16">
      <div ref={ref} className="max-w-[1400px] mx-auto">
        {}
        <div className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 mb-16 md:mb-20 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="lg:col-span-5">
            <div className="font-mono text-xs tracking-[0.2em] mb-8 text-primary">PORTFOLIO</div>
            <h2 className="font-default font-medium text-4xl md:text-6xl lg:text-[72px] leading-[1.02] tracking-tight mb-8">
              Artistry Captured<br />In Every Detail.
            </h2>
            <p className="text-base text-secondary leading-relaxed max-w-md">
              A curated collection of bridal elegance, high-fashion editorial looks, and transformative beauty sessions. Every look is crafted to highlight your natural radiance.
            </p>
          </div>

          {}
          <div className="lg:col-span-6 lg:col-start-7 flex lg:items-end lg:justify-end">
            <div className="flex flex-wrap gap-x-6 gap-y-3 lg:justify-end">
              {filters.map((f, i) => <Button key={f.id} data-index={i} onClick={() => setActiveFilter(f.id)} variant="ghost" className={`font-mono text-xs tracking-[0.2em] py-1 px-0 h-auto border-b transition-colors duration-300 ${activeFilter === f.id ? "border-b-primary hover:bg-transparent" : "border-b-transparent text-secondary hover:text-foreground hover:bg-transparent"}`} style={activeFilter === f.id ? {
              color: "var(--primary)"
            } : undefined}>
                  {f.label}
                </Button>)}
            </div>
          </div>
        </div>

        {}
        <div className="h-px w-full bg-border mb-6" />

        {}
        <div className="flex flex-wrap items-center justify-between gap-4 mb-6 font-mono text-[11px] tracking-[0.18em] text-secondary">
          <span>LOOKS — {String(filtered.length).padStart(2, "0")}</span>
          <span>STYLE // ORGANIC LUXURY</span>
          <span>STUDIO // JOANNE GLOW</span>
        </div>

        {}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-4 [column-fill:_balance]">
          {filtered.map((frame, i) => <div key={frame.id} data-index={i} className={`relative break-inside-avoid mb-4 group cursor-pointer overflow-hidden ${frame.aspect}`} onClick={() => setOpenId(frame.id)}>
              <img src={frame.src} data-wvc-srcset={frame.srcset} data-wvc-sizes={frame.sizes} alt={frame.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]" />

              {}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{
            background: "radial-gradient(ellipse at center, transparent 40%, hsl(30 10% 15% / 0.55) 100%)"
          }} />

              {}
              <span className="absolute top-3 left-3 w-5 h-5 border-t border-l border-foreground/40 group-hover:border-primary transition-colors duration-300" />
              <span className="absolute top-3 right-3 w-5 h-5 border-t border-r border-foreground/40 group-hover:border-primary transition-colors duration-300" />
              <span className="absolute bottom-3 left-3 w-5 h-5 border-b border-l border-foreground/40 group-hover:border-primary transition-colors duration-300" />
              <span className="absolute bottom-3 right-3 w-5 h-5 border-b border-r border-foreground/40 group-hover:border-primary transition-colors duration-300" />

              {}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500 pointer-events-none">
                <div className="w-16 h-16 border border-primary/70 flex items-center justify-center backdrop-blur-sm" style={{
              background: "hsl(30 10% 15% / 0.3)"
            }}>
                  <Play className="w-5 h-5 fill-current text-primary" />
                </div>
              </div>

              {}
              <div className="absolute top-3 right-10 font-mono text-[10px] tracking-[0.2em] text-foreground/60">
                LOOK.{String(frame.id).padStart(3, "0")}
              </div>

              {}
              <div className="absolute bottom-0 left-0 right-0 px-4 py-3 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out" style={{
            background: "linear-gradient(to top, hsl(30 10% 15% / 0.85), transparent)"
          }}>
                <div className="font-mono text-[11px] tracking-[0.15em] text-white">
                  {frame.project} · {frame.location} · {frame.year}
                </div>
              </div>
            </div>)}
        </div>

        {}
        <div className="flex justify-center mt-20 md:mt-24">
          <Button variant="ghost" className="group font-mono text-xs tracking-[0.25em] px-8 py-6 border border-border hover:border-primary hover:bg-transparent transition-colors duration-300 text-foreground">
            VIEW FULL PORTFOLIO
            <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover:translate-x-2 text-primary" />
          </Button>
        </div>
      </div>

      {}
      <Dialog open={openId !== null} onOpenChange={o => !o && setOpenId(null)}>
        <DialogContent className="max-w-6xl w-[95vw] p-0 border-border bg-background overflow-hidden">
          <DialogTitle className="sr-only">
            {activeFrame ? activeFrame.project : "Portfolio look"}
          </DialogTitle>
          {activeFrame && <div className="relative">
              <div className="aspect-video w-full bg-muted relative">
                <img src={activeFrame.src} data-wvc-srcset={activeFrame.srcset} data-wvc-sizes={activeFrame.sizes} alt={activeFrame.alt} className="w-full h-full object-cover" />
                <span className="absolute top-4 left-4 w-6 h-6 border-t-2 border-l-2 border-primary" />
                <span className="absolute top-4 right-4 w-6 h-6 border-t-2 border-r-2 border-primary" />
                <span className="absolute bottom-4 left-4 w-6 h-6 border-b-2 border-l-2 border-primary" />
                <span className="absolute bottom-4 right-4 w-6 h-6 border-b-2 border-r-2 border-primary" />
              </div>
              <div className="px-6 py-5 border-t border-border flex flex-wrap items-center justify-between gap-4">
                <div>
                  <div className="font-mono text-[11px] tracking-[0.2em] mb-1 text-primary">
                    LOOK.{String(activeFrame.id).padStart(3, "0")} · {activeFrame.year}
                  </div>
                  <div className="font-default font-medium text-xl tracking-tight">
                    {activeFrame.project}
                  </div>
                </div>
                <div className="font-mono text-xs tracking-[0.15em] text-secondary">
                  {activeFrame.location} · ARTISTRY · JOANNE GLOW
                </div>
              </div>
            </div>}
        </DialogContent>
      </Dialog>
    </section>;
}